import { COLORS } from '@/constants/colors';
import { Link } from '@/config/i18n/navigation';
import styled from 'styled-components';

export const Container = styled.header`
  width: 100%;
  margin: 0 auto;
  padding: 16px 0;
  position: relative;
  z-index: 1200;
  background-color: ${COLORS.white};
  border-bottom: 1px solid ${COLORS['neutral/200']};
  position: sticky;
  top: 0;
`;

export const Logo = styled(Link)`
  width: 189px;
  height: 28px;

  svg {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const MenuBlockWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: fit-content;
  padding: 0 50px;
  max-width: 1350px;
  margin: 0 auto;

  @media (max-width: 1280px) {
    padding: 0 24px;
  }
`;

export const MenuWrapper = styled.nav`
  display: flex;
  align-items: center;
  gap: 42px;
`;

export const DesktopNav = styled.div`
  display: flex;
  align-items: center;
  gap: 42px;

  @media (max-width: 1280px) {
    display: none;
  }
`;

export const MobileControls = styled.div`
  display: none;
  align-items: center;

  @media (max-width: 1280px) {
    display: flex;
  }
`;

export const BurgerMenuWrapper = styled.nav`
  display: flex;
  flex-direction: column;
`;

export const BurgerMenuHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
`;

export const LogoLightWrapper = styled.span`
  svg path:not([fill='#D25D3E']) {
    fill: white;
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;

  svg path {
    fill: white;
  }
`;

export const BurgerAuthWrapper = styled.div`
  width: 100%;

  button {
    width: 100%;
    justify-content: center;
  }
`;

export const Tagline = styled.div`
  position: absolute;
  bottom: 30px;
  right: 200px;
  z-index: 10;

  @media (max-width: 355px) {
    right: 75px;
  }
`;

export const LinkStyled = styled(Link)`
  color: ${COLORS['primary/800']};
  cursor: pointer;
  transition: color 0.2s;

  &:hover {
    color: ${COLORS['secondary/500']};
    cursor: pointer;
  }
`;

export const BurgerLinkStyled = styled(Link)<{ $isActive?: boolean }>`
  color: ${COLORS.white};
  cursor: pointer;
  display: block;
  padding: 16px 20px;
  -webkit-tap-highlight-color: transparent;
  outline: none;
  border-radius: 8px;
  background: ${({ $isActive }) => ($isActive ? '#486591' : 'transparent')};

  &:hover,
  &:focus-visible {
    background: rgba(255, 255, 255, 0.06);
  }

  &:active {
    background: #6787b6;
    color: ${COLORS['secondary/500']};
  }
`;

export const BurgerMenuList = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const BurgerMenuContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
`;
